import React, { useState } from 'react';
import { Badge, Avatar, Dropdown, Menu, message } from 'antd';
import { observer } from 'mobx-react-lite';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useStores } from '@store';
import { useNavigate } from 'react-router-dom';
import classnames from 'classnames';
import logo from './logo';
import s from './index.module';

const Header = observer((props) => {
  // const [name, setName] = useState('小红花');
  const { application } = useStores();
  const navigate = useNavigate();
  const {name, avatar} = application.user || {};
  //   const name = '小红花';
  console.log('application', application.user);
  const logout = async () => {
    const res = await application.userLogout();
    if(res.code !== 0){
      message.error(res.msg || 'error');
    }
    navigate('/login');
    message.success('已退出')
  };
  const menu = (
    <Menu>
      <Menu.Item key="0">
        <div onClick={logout}>
          <LogoutOutlined /> 退出
        </div>
      </Menu.Item>
    </Menu>
  );
  return (
    <div className={s.header}>
      <div className={s.logo}>
        <img className={classnames(s.logoIcon)} src={logo} alt="" />
        <h1 className={s.title}>商家后台</h1>
      </div>

      <Badge count={0} size="small">
        <Avatar icon={<UserOutlined />} src={avatar || 'https://joeschmoe.io/api/v1/random'} />
      </Badge>
      <Dropdown overlay={menu} placement="bottomRight">
        <span className={s.username}>{name}</span>
      </Dropdown>
    </div>
  );
});

export default Header;
